import $ from 'jquery'
import Block from '../../block'

export default class ShoppingcartPopup extends Block {
	static title = 'shoppingcart-popup'

	constructor($el) {
		super($el)

		$(() => {
			this.$el.removeClass('hidden')
		})

		this.drawer = this.$el.findElement('drawer')
		this.close = this.$el.findElement('close')

		this.close.on('click', () => {
			this.drawer.get(0).hide()
		})

		$('[shoppingcart-button]').on('click', () => {
			this.drawer.get(0).show()
		})

		$(document).on('shoppingcart:open', () => {
			this.drawer.get(0).show()
		})

		$(document).on('product:add', (index, data) => {
			this.$el.findElement('count').text(data.count)

			this.drawer.get(0).show()
		})

		$(document).on('product:remove', (index, data) => {
			this.$el.findElement('count').text(data.count)
		})

		$(document).on('product:update', (index, data) => {
			this.$el.findElement('count').text(data.count)
		})
	}
}
